let isExpanded = false;

// 点击“View All Reviews / Hide Reviews”按钮
document.getElementById('toggle-reviews-button').addEventListener('click', function () {
  const items = document.querySelectorAll('.review-item');
  isExpanded = !isExpanded;

  items.forEach(item => {
    if (isExpanded) {
      item.classList.add('show');
    } else {
      item.classList.remove('show');
    }
  });

  this.textContent = isExpanded ? 'Hide Reviews' : 'View All Reviews';
});

// 点击 Filter Reviews
document.getElementById('filter-button').addEventListener('click', function () {
  const selectedInput = document.querySelector('input[name="filter-tag"]:checked');
  const selectedTag = selectedInput ? selectedInput.value.trim().toLowerCase() : null;
  const allItems = document.querySelectorAll('.review-item');

  if (selectedTag) {
    allItems.forEach(item => {
      const tags = item.getAttribute('data-tag').toLowerCase().split(',').map(t => t.trim());
      const match = tags.includes(selectedTag);
      if (match) {
        item.classList.add('show');
      } else {
        item.classList.remove('show');
      }
    });

    isExpanded = true;
    document.getElementById('toggle-reviews-button').textContent = 'Hide Reviews';

  } else {
    // 如果没筛选项，根据 isExpanded 显示或隐藏全部
    allItems.forEach(item => {
      if (isExpanded) {
        item.classList.add('show');
      } else {
        item.classList.remove('show');
      }
    });
  }
});
